import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pt-[20px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full mx-auto" }
const _hoisted_3 = {
  class: "pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]",
  id: "niceNavigation"
}
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = {
  class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]",
  id: "niceForm"
}
const _hoisted_6 = { class: "bg-white rounded-lg shadow-md p-6 mb-8" }
const _hoisted_7 = {
  key: 0,
  class: "mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg"
}
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = { class: "mb-6" }
const _hoisted_10 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_11 = {
  class: "my-[2.5%] text-xl font-normal",
  id: "AdvancedOptions"
}
const _hoisted_12 = {
  key: 0,
  class: "bi-chevron-down ml-[5px] text-[#db0720]"
}
const _hoisted_13 = {
  key: 1,
  class: "bi-chevron-right ml-[5px] text-[#db0720]"
}
const _hoisted_14 = { class: "bg-gray-50 p-4 rounded" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "flex items-center mb-4" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = {
  class: "flex flex-wrap gap-3 mb-6",
  style: {"width":"100%"}
}
const _hoisted_20 = {
  key: 1,
  class: "bg-white rounded-lg p-4 mb-6 border border-gray-200"
}
const _hoisted_21 = { class: "flex flex-col space-y-4" }
const _hoisted_22 = { class: "flex justify-between items-center mb-1" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = { class: "ml-2 font-semibold" }
const _hoisted_25 = {
  key: 0,
  class: "ml-1 text-sm text-gray-500"
}
const _hoisted_26 = {
  key: 1,
  class: "ml-2 px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded"
}
const _hoisted_27 = {
  key: 2,
  class: "ml-2 text-red-600"
}
const _hoisted_28 = {
  key: 3,
  class: "ml-2 animate-pulse text-blue-600"
}
const _hoisted_29 = {
  key: 4,
  class: "ml-2 text-green-600"
}
const _hoisted_30 = { class: "font-bold" }
const _hoisted_31 = { class: "text-sm text-gray-700 flex items-center" }
const _hoisted_32 = {
  key: 0,
  class: "ml-2 animate-pulse text-blue-500"
}
const _hoisted_33 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-3 gap-2 mt-2"
}
const _hoisted_34 = {
  key: 0,
  class: "text-xs text-gray-600 bg-gray-50 p-2 rounded"
}
const _hoisted_35 = {
  key: 1,
  class: "text-xs text-gray-600 bg-gray-50 p-2 rounded"
}
const _hoisted_36 = {
  key: 2,
  class: "text-xs text-gray-600 bg-gray-50 p-2 rounded"
}
const _hoisted_37 = {
  key: 3,
  class: "text-xs text-gray-600 bg-gray-50 p-2 rounded"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 1,
  class: "mt-1 text-sm text-gray-600 bg-gray-50 p-3 rounded"
}
const _hoisted_40 = { class: "font-medium mb-1" }
const _hoisted_41 = {
  key: 0,
  class: "mt-2 text-xs"
}
const _hoisted_42 = { class: "font-medium" }
const _hoisted_43 = {
  key: 2,
  class: "mt-1 text-sm text-gray-600 bg-gray-50 p-3 rounded"
}
const _hoisted_44 = { class: "flex justify-between items-center mb-2" }
const _hoisted_45 = { class: "text-xs space-y-1" }
const _hoisted_46 = { class: "text-gray-500" }
const _hoisted_47 = { class: "ml-1" }
const _hoisted_48 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_49 = {
  key: 4,
  class: "mt-1 text-sm text-red-600 bg-red-50 p-3 rounded"
}
const _hoisted_50 = {
  key: 0,
  class: "bg-white rounded-lg shadow-md p-6 mb-8"
}
const _hoisted_51 = { class: "flex justify-between items-center mb-6" }
const _hoisted_52 = { class: "flex items-center space-x-3" }
const _hoisted_53 = { class: "flex items-center space-x-2 mt-1" }
const _hoisted_54 = {
  key: 0,
  class: "px-2 py-1 bg-yellow-100 text-yellow-800 text-xs font-medium rounded-full"
}
const _hoisted_55 = { class: "text-sm text-gray-600" }
const _hoisted_56 = { class: "flex space-x-2" }
const _hoisted_57 = { class: "mb-8" }
const _hoisted_58 = { class: "grid grid-cols-2 md:grid-cols-4 gap-6" }
const _hoisted_59 = { class: "bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-xl p-6 text-center" }
const _hoisted_60 = { class: "text-3xl font-bold text-blue-800" }
const _hoisted_61 = { class: "bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-xl p-6 text-center" }
const _hoisted_62 = { class: "text-3xl font-bold text-purple-800" }
const _hoisted_63 = { class: "bg-gradient-to-br from-orange-50 to-orange-100 border border-orange-200 rounded-xl p-6 text-center" }
const _hoisted_64 = { class: "text-3xl font-bold text-orange-800" }
const _hoisted_65 = { class: "bg-gradient-to-br from-green-50 to-green-100 border border-green-200 rounded-xl p-6 text-center" }
const _hoisted_66 = { class: "text-3xl font-bold text-green-800" }
const _hoisted_67 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_68 = { class: "flex justify-between items-center mb-6" }
const _hoisted_69 = {
  key: 0,
  class: "bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm"
}
const _hoisted_70 = { class: "divide-y divide-gray-100" }
const _hoisted_71 = { class: "grid grid-cols-3 gap-4 items-center" }
const _hoisted_72 = { class: "font-medium text-gray-900" }
const _hoisted_73 = { class: "text-gray-600" }
const _hoisted_74 = { class: "text-gray-600" }
const _hoisted_75 = { class: "px-2 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full" }
const _hoisted_76 = { class: "mb-6" }
const _hoisted_77 = { class: "flex justify-between items-center" }
const _hoisted_78 = {
  key: 1,
  class: "space-y-8"
}
const _hoisted_79 = { class: "bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200" }
const _hoisted_80 = { class: "flex justify-between items-center" }
const _hoisted_81 = { class: "flex items-center space-x-3" }
const _hoisted_82 = { class: "w-8 h-8 bg-[#db0720] text-white rounded-full flex items-center justify-center font-bold text-sm" }
const _hoisted_83 = { class: "text-xl font-bold text-gray-800" }
const _hoisted_84 = { class: "flex items-center space-x-2" }
const _hoisted_85 = { class: "px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full" }
const _hoisted_86 = { class: "p-6" }
const _hoisted_87 = { class: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6" }
const _hoisted_88 = {
  class: "relative aspect-video bg-gray-100 overflow-hidden",
  style: {"min-height":"200px"}
}
const _hoisted_89 = ["src"]
const _hoisted_90 = { class: "absolute bottom-2 right-2 px-2 py-1 bg-black bg-opacity-75 text-white text-xs font-medium rounded" }
const _hoisted_91 = { class: "p-4" }
const _hoisted_92 = { class: "font-bold text-gray-900 text-lg mb-2 line-clamp-2 leading-tight" }
const _hoisted_93 = { class: "text-sm font-medium text-gray-600 mb-2 line-clamp-1" }
const _hoisted_94 = { class: "text-sm text-gray-500 mb-4 line-clamp-3 leading-relaxed" }
const _hoisted_95 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_96 = { class: "space-y-2" }
const _hoisted_97 = { class: "text-sm text-gray-600 truncate flex-1 mr-3" }
const _hoisted_98 = ["onClick"]
const _hoisted_99 = { class: "flex justify-between items-center w-full" }
const _hoisted_100 = { class: "grid grid-cols-2 gap-8" }
const _hoisted_101 = { class: "space-y-4" }
const _hoisted_102 = { class: "pb-4 border-b border-gray-200" }
const _hoisted_103 = { class: "flex items-start space-x-3" }
const _hoisted_104 = { class: "flex-1" }
const _hoisted_105 = { class: "text-lg font-bold text-gray-900 leading-tight" }
const _hoisted_106 = { class: "text-sm text-gray-600 mt-1" }
const _hoisted_107 = ["src"]
const _hoisted_108 = { class: "absolute bottom-3 right-3 px-3 py-1 bg-black bg-opacity-75 text-white text-sm font-medium rounded-lg" }
const _hoisted_109 = { class: "bg-gray-50 rounded-lg p-4" }
const _hoisted_110 = { class: "text-sm text-gray-600 leading-relaxed" }
const _hoisted_111 = { class: "grid grid-cols-2 gap-4 text-sm" }
const _hoisted_112 = { class: "bg-gray-50 rounded-lg p-3" }
const _hoisted_113 = { class: "ml-2 text-gray-600" }
const _hoisted_114 = { class: "bg-gray-50 rounded-lg p-3" }
const _hoisted_115 = { class: "ml-2 text-gray-600" }
const _hoisted_116 = { class: "space-y-4" }
const _hoisted_117 = { class: "pb-4 border-b border-gray-200" }
const _hoisted_118 = { class: "flex items-start justify-between" }
const _hoisted_119 = { class: "flex items-start space-x-3 flex-1" }
const _hoisted_120 = { class: "flex-1" }
const _hoisted_121 = { class: "text-lg font-bold text-gray-900 leading-tight" }
const _hoisted_122 = { class: "text-sm text-gray-600 mt-1" }
const _hoisted_123 = { class: "ml-4" }
const _hoisted_124 = ["src"]
const _hoisted_125 = { class: "absolute bottom-3 right-3 px-3 py-1 bg-black bg-opacity-75 text-white text-sm font-medium rounded-lg" }
const _hoisted_126 = { class: "bg-gray-50 rounded-lg p-4" }
const _hoisted_127 = { class: "text-sm text-gray-600 leading-relaxed" }
const _hoisted_128 = { class: "grid grid-cols-2 gap-4 text-sm" }
const _hoisted_129 = { class: "bg-gray-50 rounded-lg p-3" }
const _hoisted_130 = { class: "ml-2 text-gray-600" }
const _hoisted_131 = { class: "bg-gray-50 rounded-lg p-3" }
const _hoisted_132 = { class: "ml-2 text-gray-600" }
const _hoisted_133 = { class: "mt-8 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-6 border border-gray-200" }
const _hoisted_134 = { key: 0 }
const _hoisted_135 = { class: "mb-6" }
const _hoisted_136 = { class: "flex justify-between items-center mb-3" }
const _hoisted_137 = { class: "flex items-center space-x-2" }
const _hoisted_138 = { class: "bg-gray-200 rounded-full h-4" }
const _hoisted_139 = { key: 0 }
const _hoisted_140 = { class: "bg-white rounded-lg border border-gray-200 overflow-hidden" }
const _hoisted_141 = { class: "divide-y divide-gray-100" }
const _hoisted_142 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_143 = { class: "text-sm text-gray-600" }
const _hoisted_144 = { class: "flex justify-end space-x-3 w-full" }

import { ref, watch, onMounted, onUnmounted, computed } from 'vue'
    import { useRouter } from 'vue-router'
    import niceNavigation from '@/components/SubNavigations/TheNiceNavigation.vue'
    import useNiceStore from '@/utils/useNiceStore'
    import { useMediaStore } from '@/utils/useMediaStore'
    import VideoThumbnail from '@/components/Media/VideoThumbnail.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import FormInput from '@/components/Offers/FormInput.vue'
    import FormSelect from '@/components/Offers/FormSelect.vue'
    import { v4 as uuidv4 } from 'uuid'
    import type { ActivityLogEntry, ProcessingStats } from '@/stores/NiceStore'
    import {
        mockDeduplicationResponse,
        mockStageProgression,
        mockActivityLogEntries,
    } from '@/constants/mockDeduplicationResponse'

    // Import from store with reactive refs
    
export default /*@__PURE__*/_defineComponent({
  __name: 'Nice',
  setup(__props) {

    const {
        deduplicationReport,
        loading: dedupLoading,
        progress,
        statusMessage,
        errorMessage,
        currentStage,
        currentSubstage,
        elapsedSeconds,
        etaSeconds,
        totalVideos,
        processedVideos,
        duplicateCount,
        detailedStatusMessage,
        stageName,
        substageName,
        formattedElapsedTime,
        formattedEtaTime,
        processingStats,
        activityLog,
        latestActivities,
        stageTimes,
        stageDescription,
        substageDescription,
        resetState,
        runDeduplication,
        getSimilarityDetails,
        getStageDescription,
        getSubstageDescription,
        fetchDeduplicationReport,
        formatMediaId,
    } = useNiceStore()

    // Local state for video deduplication settings
    const userIdInput = ref<string>('')
    const similarityMethod = ref<string>('default')
    const processingPriority = ref<string>('normal')
    const useCache = ref<boolean>(true)
    const savePreferences = ref<boolean>(true)
    const showAdvancedOptions = ref<boolean>(false)

    // UI state
    const showClusters = ref<boolean>(true)
    const showStageTimes = ref<boolean>(false)
    const showActivityLog = ref<boolean>(false)
    const hasRun = ref<boolean>(false)
    const showCompareModal = ref<boolean>(false)
    const compareData = ref<any>(null)
    const selectedComparisonId = ref<string>('')
    const isExecuting = ref<boolean>(false)

    // Marked videos
    const markedForDeletion = ref<Set<string>>(new Set())

    // Debug mode configuration
    const debugMode = ref<boolean>(true)
    const showDebugToggle = ref<boolean>(true) // Set to false to hide the debug toggle
    let debugInterval: number | null = null

    // Additional debug mode variables (not available from store)
    const totalCount = ref<number>(0)
    const currentCount = ref<number>(0)

    // Computed property to ensure debug mode is only active when toggle is shown
    const isDebugModeActive = computed(() => {
        return showDebugToggle.value && debugMode.value
    })

    // Media store
    const mediaStore = useMediaStore()

    // Form ref
    const formRef = ref(null)

    // Computed properties for progress display
    const progressDisplay = computed(() => {
        return progress.value.toFixed(1)
    })

    const safeProgressWidth = computed(() => {
        return Math.max(0, Math.min(100, progress.value))
    })

    // Computed property to check if we have processing stats
    const hasProcessingStats = computed(() => {
        return (
            processingStats.value &&
            (processingStats.value.extraction_speed > 0 ||
                processingStats.value.comparison_speed > 0 ||
                processingStats.value.feature_cache_hits > 0 ||
                processingStats.value.current_memory_usage_mb > 0)
        )
    })

    // Computed property for cache status text
    const cacheStatusText = computed(() => {
        const hits = processingStats.value.feature_cache_hits || 0
        const misses = processingStats.value.feature_cache_misses || 0
        const total = hits + misses

        if (total === 0) return 'Keine Daten'

        const hitRate = (hits / total) * 100
        return `${hits}/${total} (${hitRate.toFixed(0)}%)`
    })

    // Computed property to check if we have valid stage times
    const hasValidStageTimes = computed(() => {
        if (!stageTimes.value || typeof stageTimes.value !== 'object') return false
        return Object.values(stageTimes.value).some(
            (time) => time && typeof time === 'number' && time > 0
        )
    })

    // Labels for similarity components
    const componentLabels: Record<string, string> = {
        visual_similarity: 'Visuelle Ähnlichkeit',
        audio_similarity: 'Audio-Ähnlichkeit',
        metadata_similarity: 'Metadaten-Ähnlichkeit',
        temporal_similarity: 'Zeitliche Ähnlichkeit',
    }

    // Generate a unique job ID
    function generateRandomJobId(): string {
        return uuidv4().replace(/-/g, '').substring(0, 20)
    }

    // Debug mode: Use imported mock deduplication report
    function createDummyDeduplicationReport() {
        // Return the imported mock data with a fresh timestamp
        const report = {
            ...mockDeduplicationResponse,
            timestamp: new Date().toISOString(),
        }

        // DEBUG: Verify links exist in the mock data
        console.log('🔍 Mock data check:', {
            hasLinks: report.duplicate_clusters[0]?.videos[0]?.links?.length || 0,
            firstLink: report.duplicate_clusters[0]?.videos[0]?.links?.[1],
        })

        return report
    }

    // Debug mode: Simulate deduplication process using imported mock data
    async function runDebugDeduplication(): Promise<void> {
        try {
            // Uses mock data from constants/mockDeduplicationResponse.ts
            // DON'T call resetState() in debug mode as it might trigger store calls
            // Instead manually reset only the values we need

            // Set initial state manually for debug mode
            progress.value = 0
            currentStage.value = 'initializing'
            currentSubstage.value = 'setup'
            statusMessage.value = 'Initialisiere Debug-Deduplikation...'
            elapsedSeconds.value = 0
            hasRun.value = true
            errorMessage.value = undefined

            // Reset debug-specific counters
            totalCount.value = 0
            currentCount.value = 0
            totalVideos.value = 0
            processedVideos.value = 0
            duplicateCount.value = 0

            // Initialize processing stats for debug mode
            processingStats.value = {
                videos_per_second: 0,
                pairs_per_second: 0,
                current_memory_usage_mb: 0,
                peak_memory_usage_mb: 0,
                last_extracted_video: '',
                last_compared_pair: '',
                extraction_speed: 0,
                comparison_speed: 0,
                feature_cache_hits: 0,
                feature_cache_misses: 0,
            }

            // Initialize other debug values
            stageTimes.value = {}
            etaSeconds.value = null

            // Stage progression for debug mode
            const debugStages = mockStageProgression

            let totalElapsed = 0
            let activityLogIndex = 0

            // Initialize activity log for debug mode
            activityLog.value = []

            // Initialize processing stats values that we'll use
            processingStats.value.videos_per_second = 0
            processingStats.value.pairs_per_second = 0
            processingStats.value.current_memory_usage_mb = 0
            processingStats.value.peak_memory_usage_mb = 0
            processingStats.value.last_extracted_video = ''
            processingStats.value.last_compared_pair = ''
            processingStats.value.extraction_speed = 0
            processingStats.value.comparison_speed = 0
            processingStats.value.feature_cache_hits = 0
            processingStats.value.feature_cache_misses = 0

            // Process stages
            for (const [index, stageInfo] of debugStages.entries()) {
                if (!hasRun.value) break // Check if cancelled

                // Update stage
                currentStage.value = stageInfo.stage
                currentSubstage.value = stageInfo.substage
                progress.value = stageInfo.progress

                // Update processing stats based on stage
                if (stageInfo.stage === 'feature_extraction') {
                    totalVideos.value = mockDeduplicationResponse.stats.total_videos
                    processedVideos.value = Math.floor(
                        ((stageInfo.progress - 20) / 35) * totalVideos.value
                    )
                    processingStats.value.extraction_speed = 45.2
                    processingStats.value.current_memory_usage_mb = 1250 + Math.random() * 200
                    processingStats.value.feature_cache_hits = Math.floor(
                        processedVideos.value * 0.65
                    )
                    processingStats.value.feature_cache_misses =
                        processedVideos.value - processingStats.value.feature_cache_hits
                    processingStats.value.last_extracted_video =
                        mockDeduplicationResponse.duplicate_clusters[0].videos[
                            Math.floor(Math.random() * 3)
                        ].media_id
                } else if (stageInfo.stage === 'comparison') {
                    totalCount.value =
                        (mockDeduplicationResponse.stats.total_videos *
                            (mockDeduplicationResponse.stats.total_videos - 1)) /
                        2
                    currentCount.value = Math.floor(
                        ((stageInfo.progress - 55) / 20) * totalCount.value
                    )
                    processingStats.value.comparison_speed = 180.7
                    const randomCluster =
                        mockDeduplicationResponse.duplicate_clusters[
                            Math.floor(
                                Math.random() * mockDeduplicationResponse.duplicate_clusters.length
                            )
                        ]
                    const video1 = randomCluster.videos[0]
                    const video2 = randomCluster.videos[1]
                    processingStats.value.last_compared_pair = `${video1.media_id}-${video2.media_id}`
                } else if (stageInfo.stage === 'clustering') {
                    duplicateCount.value = mockDeduplicationResponse.stats.duplicate_pairs
                }

                // Update elapsed time
                totalElapsed += stageInfo.duration
                elapsedSeconds.value = totalElapsed / 1000

                // Calculate ETA
                if (stageInfo.progress < 100) {
                    const remainingProgress = 100 - stageInfo.progress
                    etaSeconds.value =
                        ((totalElapsed / stageInfo.progress) * remainingProgress) / 1000
                }

                // Add activity log entries
                if (activityLogIndex < mockActivityLogEntries.length && stageInfo.progress > 0) {
                    // Add appropriate number of log entries based on progress
                    const entriesPerStage = Math.ceil(
                        mockActivityLogEntries.length / debugStages.length
                    )
                    const stageBoundary = (index + 1) * entriesPerStage

                    while (
                        activityLogIndex < Math.min(stageBoundary, mockActivityLogEntries.length)
                    ) {
                        activityLog.value.push({
                            timestamp: new Date().toISOString(),
                            activity: `${mockActivityLogEntries[activityLogIndex]} ${userIdInput.value}`,
                        })
                        activityLogIndex++
                    }
                }

                // Update stage times
                if (index > 0) {
                    const prevStage = debugStages[index - 1].stage
                    if (!stageTimes.value[prevStage]) {
                        stageTimes.value[prevStage] = 0
                    }
                    stageTimes.value[prevStage] += debugStages[index - 1].duration / 1000
                }

                // For the current stage being processed
                if (!stageTimes.value[stageInfo.stage]) {
                    stageTimes.value[stageInfo.stage] = 0
                }

                // Wait for the stage duration
                await new Promise((resolve) => {
                    debugInterval = window.setTimeout(resolve, stageInfo.duration)
                })
            }

            // Set final report when completed
            if (hasRun.value && progress.value === 100) {
                deduplicationReport.value = createDummyDeduplicationReport()

                // DEBUG: Check if links exist after setting
                console.log('🔍 After setting report:', {
                    hasReport: !!deduplicationReport.value,
                    firstVideoHasLinks: !!deduplicationReport.value?.duplicate_clusters?.[0]?.videos?.[0]?.links,
                    linksCount: deduplicationReport.value?.duplicate_clusters?.[0]?.videos?.[0]?.links?.length,
                })

                currentStage.value = 'completed'
                statusMessage.value = 'Debug-Deduplikation abgeschlossen'
                etaSeconds.value = null
                debugDeduplicationData()

                // Update final stage time and ensure all stages have times
                stageTimes.value['completed'] = 0.2
                stageTimes.value['report_generation'] = stageTimes.value['report_generation'] || 0.3
                stageTimes.value['clustering'] = stageTimes.value['clustering'] || 1.0
                stageTimes.value['comparison'] = stageTimes.value['comparison'] || 1.8
                stageTimes.value['feature_extraction'] =
                    stageTimes.value['feature_extraction'] || 2.4
                stageTimes.value['api_fetch'] = stageTimes.value['api_fetch'] || 1.2
                stageTimes.value['initializing'] = stageTimes.value['initializing'] || 0.8

                // Add final activity log entry if not already added
                if (activityLogIndex < mockActivityLogEntries.length) {
                    activityLog.value.push({
                        timestamp: new Date().toISOString(),
                        activity: mockActivityLogEntries[mockActivityLogEntries.length - 1],
                    })
                }
            }
        } catch (error) {
            console.error('Debug deduplication error:', error)
            errorMessage.value = 'Debug-Deduplikation fehlgeschlagen'
            currentStage.value = 'error'
            hasRun.value = true // Keep hasRun true to show the error state
        } finally {
            dedupLoading.value = false
            isExecuting.value = false
        }
    }

    // Execute deduplication (with debug mode support)
    async function executeDeduplication(): Promise<void> {
        // Prevent double execution
        if (isExecuting.value || dedupLoading.value) {
            console.log('Deduplication already in progress, ignoring click')
            return
        }

        if (!userIdInput.value) {
            alert('Bitte geben Sie eine Benutzer‑ID ein')
            return
        }

        // Set local execution flag immediately
        isExecuting.value = true
        dedupLoading.value = true

        try {
            if (isDebugModeActive.value) {
                // DEBUG MODE: Use imported mock data from constants/mockDeduplicationResponse.ts
                console.log(
                    'Running debug mode deduplication with mock data - bypassing all backend calls...'
                )
                clearDeduplicationState()
                markedForDeletion.value.clear()
                showActivityLog.value = true
                await runDebugDeduplication()
            } else {
                // PRODUCTION MODE: Run real deduplication
                console.log('Running production mode deduplication...')

                // Reset any previous state first to ensure clean start
                resetState()
                clearDeduplicationState()

                // Mark that a run has started
                hasRun.value = true
                markedForDeletion.value.clear()
                showActivityLog.value = true

                // Save initial state
                saveDeduplicationState()

                // Generate random job ID and run real deduplication
                const newJobId = generateRandomJobId()
                const options = {
                    method: similarityMethod.value,
                    priority: processingPriority.value,
                    useCache: useCache.value,
                }

                // Start the deduplication process with the store
                await runDeduplication(userIdInput.value, newJobId, options)
            }
        } catch (error) {
            console.error('Error during deduplication:', error)
            alert('Fehler beim Starten der Deduplikation. Bitte versuchen Sie es erneut.')
        } finally {
            // Always reset the execution flag
            isExecuting.value = false
            if (isDebugModeActive.value) {
                dedupLoading.value = false
            }
        }
    }

    // Cancel deduplication process (updated for debug mode)
    function cancelDeduplication(): void {
        if (confirm('Möchten Sie die Deduplikation wirklich abbrechen?')) {
            // Clear debug interval if running
            if (debugInterval !== null) {
                window.clearTimeout(debugInterval)
                debugInterval = null
            }

            // Reset debug-specific variables
            totalCount.value = 0
            currentCount.value = 0

            resetState()
            hasRun.value = false
            clearDeduplicationState()
            isExecuting.value = false
            dedupLoading.value = false
        }
    }

    // Save deduplication state to localStorage
    function saveDeduplicationState(): void {
        try {
            const state = {
                hasRun: hasRun.value,
                userIdInput: userIdInput.value,
                showActivityLog: showActivityLog.value,
                showClusters: showClusters.value,
                showStageTimes: showStageTimes.value,
                debugMode: debugMode.value,
                // Store a snapshot of the store state
                deduplicationReport: deduplicationReport.value,
                progress: progress.value,
                currentStage: currentStage.value,
                currentSubstage: currentSubstage.value,
                stageName: stageName.value,
                substageName: substageName.value,
                detailedStatusMessage: detailedStatusMessage.value,
                errorMessage: errorMessage.value,
                processingStats: processingStats.value,
                latestActivities: latestActivities.value,
                stageTimes: stageTimes.value,
                stageDescription: stageDescription.value,
                substageDescription: substageDescription.value,
                timestamp: new Date().toISOString(),
            }
            localStorage.setItem('dedup-state', JSON.stringify(state))
        } catch (e) {
            console.warn('Could not save deduplication state to localStorage:', e)
        }
    }

    // Load deduplication state from localStorage
    function loadDeduplicationState(): void {
        try {
            const savedState = localStorage.getItem('dedup-state')
            if (savedState) {
                const state = JSON.parse(savedState)

                // Check if the state is not too old (e.g., less than 24 hours)
                const savedTime = new Date(state.timestamp)
                const now = new Date()
                const hoursDiff = (now.getTime() - savedTime.getTime()) / (1000 * 60 * 60)

                if (hoursDiff < 24) {
                    // Restore UI state
                    hasRun.value = state.hasRun || false
                    userIdInput.value = state.userIdInput || ''
                    showActivityLog.value = state.showActivityLog || false
                    showClusters.value =
                        state.showClusters !== undefined ? state.showClusters : true
                    showStageTimes.value = state.showStageTimes || false
                    debugMode.value = state.debugMode || false

                    // If we have a completed deduplication report, restore it
                    if (state.deduplicationReport && state.progress >= 99) {
                        // Note: We can't directly set the store values here since they're reactive
                        // But we can set the report if it exists
                        console.log('Restored deduplication state from localStorage')
                    }
                } else {
                    // Clear old state
                    localStorage.removeItem('dedup-state')
                }
            }
        } catch (e) {
            console.warn('Could not load deduplication state from localStorage:', e)
            localStorage.removeItem('dedup-state')
        }
    }

    // Clear deduplication state from localStorage
    function clearDeduplicationState(): void {
        localStorage.removeItem('dedup-state')
    }

    // Reset everything (including deduplication results)
    function resetEverything(): void {
        // Clear debug interval if running
        if (debugInterval !== null) {
            window.clearTimeout(debugInterval)
            debugInterval = null
        }

        userIdInput.value = ''
        hasRun.value = false
        markedForDeletion.value.clear()
        showActivityLog.value = false

        // Reset debug-specific variables
        totalCount.value = 0
        currentCount.value = 0

        resetState() // This calls the store's resetState method
        clearDeduplicationState() // Clear localStorage

        // Also reset any component-specific state
        showCompareModal.value = false
        compareData.value = null
        isExecuting.value = false
        dedupLoading.value = false
    }

    // Save user preferences to localStorage
    function saveUserPreferences(): void {
        const preferences = {
            method: similarityMethod.value,
            priority: processingPriority.value,
            useCache: useCache.value,
            showAdvancedOptions: showAdvancedOptions.value,
            showClusters: showClusters.value,
            debugMode: showDebugToggle.value ? debugMode.value : false, // Only save debug mode if toggle is shown
            lastUserId: userIdInput.value,
        }
        localStorage.setItem('dedup-preferences', JSON.stringify(preferences))
    }

    // Load user preferences from localStorage
    function loadUserPreferences(): void {
        const savedPrefs = localStorage.getItem('dedup-preferences')
        if (savedPrefs) {
            try {
                const prefs = JSON.parse(savedPrefs)
                similarityMethod.value = prefs.method || 'default'
                processingPriority.value = prefs.priority || 'normal'
                useCache.value = prefs.useCache !== undefined ? prefs.useCache : true
                showAdvancedOptions.value = prefs.showAdvancedOptions || false
                showClusters.value = prefs.showClusters !== undefined ? prefs.showClusters : true
                // Only load debug mode if debug toggle is shown
                debugMode.value = showDebugToggle.value ? prefs.debugMode || false : false
            } catch (e) {
                // Silent error for preferences loading
            }
        }
    }

    // Export results in various formats
    function exportResults(format: string): void {
        if (!deduplicationReport.value) {
            alert('Keine Deduplikationsergebnisse zum Exportieren vorhanden')
            return
        }
        try {
            const fileName = `deduplication-results-${new Date().toISOString().substring(0, 10)}`
            let content = ''
            let dataType = ''
            let fileExtension = ''

            if (format === 'json') {
                content = JSON.stringify(deduplicationReport.value, null, 2)
                dataType = 'application/json'
                fileExtension = 'json'
            } else if (format === 'csv') {
                content = convertToCSV(deduplicationReport.value)
                dataType = 'text/csv'
                fileExtension = 'csv'
            } else if (format === 'pdf') {
                alert('PDF‑Export ist in der Demo‑Version nicht verfügbar')
                return
            }

            const blob = new Blob([content], { type: dataType })
            const url = URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = `${fileName}.${fileExtension}`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        } catch (error) {
            alert('Export der Ergebnisse fehlgeschlagen')
        }
    }

    // Convert deduplication report to CSV format
    function convertToCSV(report: any): string {
        let csv = 'Cluster,Media ID 1,Media ID 2,Titel 1,Titel 2,Ähnlichkeit\n'
        if (report.duplicate_clusters) {
            report.duplicate_clusters.forEach((cluster: any, index: number) => {
                if (!cluster.videos || cluster.videos.length < 2) return
                for (let i = 0; i < cluster.videos.length; i++) {
                    const video1 = cluster.videos[i]
                    for (let j = i + 1; j < cluster.videos.length; j++) {
                        const video2 = cluster.videos[j]
                        let similarity = 0
                        if (video1.similar_videos) {
                            const found = video1.similar_videos.find(
                                (sv: any) => sv.media_id === video2.media_id
                            )
                            if (found) similarity = found.similarity
                        }
                        csv += `${index + 1},${video1.media_id},${video2.media_id},"${video1.title}","${video2.title}",${similarity}\n`
                    }
                }
            })
        }
        return csv
    }

    // Format processing time to human-readable string
    function formatProcessingTime(seconds: number): string {
        if (seconds < 60) {
            return `${seconds.toFixed(1)} s`
        } else if (seconds < 3600) {
            const minutes = Math.floor(seconds / 60)
            const remainingSeconds = seconds % 60
            return `${minutes}m ${remainingSeconds.toFixed(0)}s`
        } else {
            const hours = Math.floor(seconds / 3600)
            const minutes = Math.floor((seconds % 3600) / 60)
            return `${hours}h ${minutes}m`
        }
    }

    // Format time seconds to human-readable string
    function formatTime(seconds: number): string {
        if (seconds < 60) {
            return `${seconds.toFixed(1)}s`
        } else if (seconds < 3600) {
            const minutes = Math.floor(seconds / 60)
            const remainingSeconds = Math.floor(seconds % 60)
            return `${minutes}m ${remainingSeconds}s`
        } else {
            const hours = Math.floor(seconds / 3600)
            const minutes = Math.floor((seconds % 3600) / 60)
            return `${hours}h ${minutes}m`
        }
    }

    // Calculate percentage of total time
    function calculatePercentage(stageTime: number): string {
        if (!stageTime || typeof stageTime !== 'number') return '0'

        const totalTime = Object.values(stageTimes.value)
            .filter((time) => time && typeof time === 'number')
            .reduce((sum, time) => sum + time, 0)

        if (totalTime === 0) return '0'
        return ((stageTime / totalTime) * 100).toFixed(1)
    }

    // Get stage display name
    function getStageDisplayName(stage: string): string {
        const stageDisplayNames: Record<string, string> = {
            initializing: 'Initialisierung',
            api_fetch: 'API-Datenabruf',
            feature_extraction: 'Merkmalsextraktion',
            comparison: 'Videovergleich',
            clustering: 'Clustering',
            report_generation: 'Berichtserstellung',
            completed: 'Abschluss',
            error: 'Fehler',
        }
        return stageDisplayNames[stage] || stage
    }

    // Format timestamp to human-readable format
    function formatTimestamp(isoString: string): string {
        try {
            const date = new Date(isoString)
            return date.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            })
        } catch (e) {
            return isoString
        }
    }

    // Mark a video for deletion
    function markForDeletion(mediaId: string): void {
        markedForDeletion.value.add(mediaId)
        alert(
            `Demomodus: ${formatMediaId(mediaId)} zum Löschen markiert (keine tatsächliche Löschung)`
        )
    }

    // Open comparison modal
    async function openCompareModal(mediaId: string, cluster: any): Promise<void> {
        if (!cluster || !cluster.videos) return
        const primaryVideo = cluster.videos.find((v: any) => v.media_id === mediaId)
        if (!primaryVideo) return

        const otherVideos = cluster.videos
            .filter((v: any) => v.media_id !== mediaId)
            .map((v: any) => {
                let similarity = 0
                if (primaryVideo.similar_videos) {
                    const found = primaryVideo.similar_videos.find(
                        (sv: any) => sv.media_id === v.media_id
                    )
                    if (found) similarity = found.similarity
                }
                return { ...v, similarity }
            })

        if (otherVideos.length === 0) {
            alert('Keine weiteren Videos in dieser Gruppe zum Vergleichen vorhanden')
            return
        }

        // Get the first comparison video
        const firstComparisonVideo = otherVideos[0]

        // Get similarity details from the store or generate them
        let detailedSimilarity = null

        if (!isDebugModeActive.value) {
            try {
                const details = await getSimilarityDetails(
                    primaryVideo.media_id,
                    firstComparisonVideo.media_id
                )

                if (details) {
                    detailedSimilarity = details
                } else {
                    // Fallback to generated details if needed
                    detailedSimilarity = generateSimilarityDetails(
                        primaryVideo,
                        firstComparisonVideo
                    )
                }
            } catch (error) {
                detailedSimilarity = generateSimilarityDetails(primaryVideo, firstComparisonVideo)
            }
        } else {
            // In debug mode, always generate similarity details
            detailedSimilarity = generateSimilarityDetails(primaryVideo, firstComparisonVideo)
        }

        compareData.value = {
            primary: primaryVideo,
            comparison: firstComparisonVideo,
            otherVideos,
            similarityDetails: detailedSimilarity,
        }
        selectedComparisonId.value = firstComparisonVideo.media_id
        showCompareModal.value = true
    }

    // Update the comparison video when selection changes
    async function updateComparisonVideo(): Promise<void> {
        if (!compareData.value || !compareData.value.otherVideos) return
        const selected = compareData.value.otherVideos.find(
            (v: any) => v.media_id === selectedComparisonId.value
        )
        if (selected) {
            compareData.value.comparison = selected

            // Get similarity details from the store or generate them
            let detailedSimilarity = null

            if (!isDebugModeActive.value) {
                try {
                    const details = await getSimilarityDetails(
                        compareData.value.primary.media_id,
                        selected.media_id
                    )

                    if (details) {
                        detailedSimilarity = details
                    } else {
                        // Fallback to generated details
                        detailedSimilarity = generateSimilarityDetails(
                            compareData.value.primary,
                            selected
                        )
                    }
                } catch (error) {
                    detailedSimilarity = generateSimilarityDetails(
                        compareData.value.primary,
                        selected
                    )
                }
            } else {
                // In debug mode, always generate similarity details
                detailedSimilarity = generateSimilarityDetails(compareData.value.primary, selected)
            }

            compareData.value.similarityDetails = detailedSimilarity
        }
    }

    // Generate detailed similarity comparison as fallback
    function generateSimilarityDetails(video1: any, video2: any): any {
        let similarity = 0
        if (video1.similar_videos) {
            const found = video1.similar_videos.find((sv: any) => sv.media_id === video2.media_id)
            if (found) similarity = found.similarity
        }

        // Create deterministic components from media IDs
        const idStr = video1.media_id + video2.media_id
        const hash = hashCode(idStr)

        // Generate components based on hash value
        const visualFactor = 0.8 + (hash % 40) / 100
        const audioFactor = 0.7 + (hash % 40) / 100
        const metadataFactor = 0.9 + (hash % 20) / 100
        const temporalFactor = 0.6 + (hash % 50) / 100

        return {
            overall: similarity,
            components: {
                visual_similarity: Math.min(0.95, Math.max(0.4, similarity * visualFactor)),
                audio_similarity: Math.min(0.95, Math.max(0.3, similarity * audioFactor)),
                metadata_similarity: Math.min(0.95, Math.max(0.5, similarity * metadataFactor)),
                temporal_similarity: Math.min(0.95, Math.max(0.2, similarity * temporalFactor)),
            },
            matching_segments: [
                {
                    start: `00:${(hash % 15).toString().padStart(2, '0')}:${(hash % 59).toString().padStart(2, '0')}`,
                    duration: `00:${(1 + (hash % 5)).toString().padStart(2, '0')}:${(hash % 59).toString().padStart(2, '0')}`,
                    confidence: 0.7 + (hash % 25) / 100,
                },
                {
                    start: `00:${((hash + 10) % 59).toString().padStart(2, '0')}:${(hash % 59).toString().padStart(2, '0')}`,
                    duration: `00:${(1 + (hash % 3)).toString().padStart(2, '0')}:${(hash % 59).toString().padStart(2, '0')}`,
                    confidence: 0.65 + (hash % 30) / 100,
                },
            ],
        }
    }

    // Simple hash function for deterministic results
    function hashCode(str: string): number {
        let hash = 0
        for (let i = 0; i < str.length; i++) {
            hash = (hash << 5) - hash + str.charCodeAt(i)
            hash |= 0 // Convert to 32bit integer
        }
        return Math.abs(hash)
    }

    // Format languages array to readable string
    function formatLanguages(languages: string[] | undefined): string {
        if (!languages || languages.length === 0) return 'Unbekannt'
        return languages.join(', ')
    }

    // Actions for the comparison modal (demo only)
    function markAsUnique(mediaId1: string, mediaId2: string): void {
        alert(
            `${isDebugModeActive.value ? 'Debug-' : 'Demo'}modus: ${formatMediaId(mediaId1)} und ${formatMediaId(mediaId2)} als einzigartig markiert`
        )
        showCompareModal.value = false
    }

    function mergeDuplicates(mediaId1: string, mediaId2: string): void {
        alert(
            `${isDebugModeActive.value ? 'Debug-' : 'Demo'}modus: ${formatMediaId(mediaId1)} und ${formatMediaId(mediaId2)} zusammengeführt`
        )
        showCompareModal.value = false
    }

    function deleteVideo(mediaId: string): void {
        markedForDeletion.value.add(mediaId)
        alert(
            `${isDebugModeActive.value ? 'Debug-' : 'Demo'}modus: ${formatMediaId(mediaId)} zum Löschen markiert`
        )
        showCompareModal.value = false
    }

    // Close compare modal
    function closeCompareModal(): void {
        showCompareModal.value = false
    }

    // Generate a thumbnail URL based on media ID and video data
    const getThumbnailUrl = (mediaId: string, videoData?: any): string => {
        // Force check the actual deduplication report if in debug mode
        if (isDebugModeActive.value && deduplicationReport.value) {
            // Find the video in the actual report
            for (const cluster of deduplicationReport.value.duplicate_clusters) {
                const video = cluster.videos.find((v: any) => v.media_id === mediaId)
                if (video && video.links) {
                    const x2Thumbnail = video.links.find((link: any) =>
                        link.rel === 'media/preview/thumbnail/x2'
                    )
                    if (x2Thumbnail?.href) {
                        return x2Thumbnail.href
                    }

                    const thumbnail = video.links.find((link: any) =>
                        link.rel === 'media/preview/thumbnail'
                    )
                    if (thumbnail?.href) {
                        return thumbnail.href
                    }
                }
            }
        }

        // Original logic for non-debug mode
        if (videoData?.thumbnail_url) {
            return videoData.thumbnail_url
        }

        if (videoData?.links && Array.isArray(videoData.links)) {
            const x2Thumbnail = videoData.links.find((link: any) =>
                link.rel === 'media/preview/thumbnail/x2'
            )
            if (x2Thumbnail?.href) {
                return x2Thumbnail.href
            }

            const thumbnail = videoData.links.find((link: any) =>
                link.rel === 'media/preview/thumbnail'
            )
            if (thumbnail?.href) {
                return thumbnail.href
            }
        }

        // This should never be reached if data is correct
        console.warn('⚠️ Falling back to placeholder for:', mediaId)
        const hash = mediaId.split('').reduce((a, b) => {
            a = (a << 5) - a + b.charCodeAt(0)
            return a & a
        }, 0)

        return `https://picsum.photos/seed/${Math.abs(hash)}/640/360`
    }

    function handleImageError(event: Event, mediaId: string): void {
        console.error('❌ Image failed to load for mediaId:', mediaId)
        const img = event.target as HTMLImageElement
        console.error('Failed URL:', img.src)

        // Try a fallback URL with a simpler approach
        const fallbackSeed = mediaId.charCodeAt(0) + mediaId.charCodeAt(1)
        const fallbackUrl = `https://picsum.photos/seed/${fallbackSeed}/640/360`
        console.log('🔄 Trying fallback URL:', fallbackUrl)

        // First try the fallback URL
        img.onerror = () => {
            console.error('❌ Fallback also failed, using SVG placeholder')
            img.src =
                'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQwIiBoZWlnaHQ9IjM2MCIgdmlld0JveD0iMCAwIDY0MCAzNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI2NDAiIGhlaWdodD0iMzYwIiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0yNTYgMTgwTDMwNCAyMDhWMTUyTDI1NiAxODBaIiBmaWxsPSIjOUI5QkEzIi8+CjxwYXRoIGQ9Ik0zMjAgMTgwQzMyMCAxOTMuMjU1IDMwOS4yNTUgMjA0IDI5NiAyMDRDMjgyLjc0NSAyMDQgMjcyIDE5My4yNTUgMjcyIDE4MEMyNzIgMTY2Ljc0NSAyODIuNzQ1IDE1NiAyOTYgMTU2QzMwOS4yNTUgMTU2IDMyMCAxNjYuNzQ1IDMyMCAxODBaIiBmaWxsPSIjOUI5QkEzIi8+Cjx0ZXh0IHg9IjMyMCIgeT0iMjAwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjNkI3MjgwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiPktlaW4gQmlsZCB2ZXJmw7xnYmFyPC90ZXh0Pgo8L3N2Zz4K'
        }

        img.src = fallbackUrl
    }

    function debugDeduplicationData(): void {
        console.log('🔍 === DEBUGGING DEDUPLICATION DATA ===')
        console.log('debugMode:', debugMode.value)
        console.log('isDebugModeActive:', isDebugModeActive.value)
        console.log('deduplicationReport exists:', !!deduplicationReport.value)

        if (deduplicationReport.value?.duplicate_clusters) {
            console.log('Number of clusters:', deduplicationReport.value.duplicate_clusters.length)

            deduplicationReport.value.duplicate_clusters.forEach((cluster: any, index: number) => {
                console.log(`\nCluster ${index + 1}:`)
                cluster.videos.forEach((video: any, vidIndex: number) => {
                    const thumbnailUrl = getThumbnailUrl(video.media_id, video)
                    console.log(`  - Video ${vidIndex + 1}:`, {
                        media_id: video.media_id,
                        title: video.title,
                        thumbnail_url: thumbnailUrl,
                        has_links: !!video.links,
                        links_count: video.links?.length || 0,
                        video_keys: Object.keys(video),
                    })

                    // Log first link if exists
                    if (video.links && video.links.length > 0) {
                        console.log(`    First link:`, video.links[0])
                    }
                })
            })
        } else {
            console.log('❌ No duplicate clusters found in deduplicationReport')
        }
        console.log('🔍 === END DEBUG ===')
    }

    // Router for navigation
    const router = useRouter()

    // Play video function
    function playVideo(mediaId: string): void {
        // Update the media store with this video
        mediaStore.playVideo(mediaId)

        // Navigate to video player page in the same window
        router.push(`/media/player/${mediaId}`)

        // Also close the compare modal if it's open
        if (showCompareModal.value) {
            showCompareModal.value = false
        }
    }

    // Watch for progress changes to save state and fetch report when needed
    watch(progress, async (newVal, oldVal) => {
        if (newVal !== oldVal) {
            // Save state whenever progress changes
            if (hasRun.value) {
                saveDeduplicationState()
            }

            // When progress reaches 100% and we don't have a report yet, fetch it explicitly (only in non-debug mode)
            if (
                !isDebugModeActive.value &&
                newVal >= 100 &&
                !deduplicationReport.value &&
                compareData.value?.jobId
            ) {
                try {
                    await fetchDeduplicationReport(compareData.value.jobId)
                } catch (error) {
                    // Silent error handling
                }
            }
        }
    })

    // Watch for deduplication report changes to save state
    watch(deduplicationReport, (newReport) => {
        if (newReport) {
            showClusters.value = true
            saveDeduplicationState()
        }
    })

    // Watch for other state changes to save
    watch([currentStage, stageName, detailedStatusMessage, errorMessage], () => {
        if (hasRun.value) {
            saveDeduplicationState()
        }
    })

    // Watch for status-related errors to automatically display activity log
    watch(errorMessage, (newError) => {
        if (newError) {
            showActivityLog.value = true
        }
    })

    // Watch debug mode changes to save preferences
    watch(isDebugModeActive, (newVal) => {
        saveUserPreferences()
    })

    // Force debug mode to false when debug toggle is hidden
    watch(
        showDebugToggle,
        (newVal) => {
            if (!newVal) {
                debugMode.value = false
            }
        },
        { immediate: true }
    )

    // Load preferences and state on mount
    onMounted(() => {
        loadUserPreferences()
        loadDeduplicationState()
    })

    // Cleanup on unmount
    onUnmounted(() => {
        if (debugInterval !== null) {
            window.clearTimeout(debugInterval)
            debugInterval = null
        }
    })

    //breadcrumbs
    const breadcrumbs = [
        {
            title: 'NICE',
            disabled: false,
            href: '/nice',
        },
        {
            title: 'Videoduplikate',
            disabled: true,
            href: '/nice/deduplication',
        },
    ]

return (_ctx: any,_cache: any) => {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(niceNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[32] || (_cache[32] = _createElementVNode("h2", { class: "text-left text-2xl font-medium mb-[3%]" }, [
            _createElementVNode("strong", null, "Steuerzentrale für Videoduplikate")
          ], -1)),
          (showDebugToggle.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                    _createElementVNode("h3", { class: "text-lg font-medium text-yellow-800" }, "Debug-Modus"),
                    _createElementVNode("p", { class: "text-sm text-yellow-600" }, " Verwendet Dummy-Daten anstelle echter Backend-Aufrufe ")
                  ], -1)),
                  _createVNode(_component_v_switch, {
                    modelValue: debugMode.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((debugMode).value = $event)),
                    color: "warning",
                    disabled: _unref(dedupLoading) || isExecuting.value
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_form, {
            onSubmit: _withModifiers(executeDeduplication, ["prevent"]),
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { fluid: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(FormInput, {
                      modelValue: userIdInput.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userIdInput).value = $event)),
                      label: "Benutzer‑ID",
                      placeholder: "Geben Sie die Benutzer-ID ein",
                      disabled: _unref(dedupLoading),
                      required: "",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  (isDebugModeActive.value || showAdvancedOptions.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("h2", _hoisted_11, [
                          _createElementVNode("span", {
                            class: "cursor-pointer",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (showAdvancedOptions.value = !showAdvancedOptions.value))
                          }, [
                            _cache[22] || (_cache[22] = _createTextVNode(" Erweiterte Optionen ", -1)),
                            (showAdvancedOptions.value)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                              : (_openBlock(), _createElementBlock("i", _hoisted_13))
                          ])
                        ]),
                        (showAdvancedOptions.value)
                          ? (_openBlock(), _createBlock(_component_v_container, {
                              key: 0,
                              fluid: ""
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_14, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _createVNode(FormSelect, {
                                      modelValue: similarityMethod.value,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((similarityMethod).value = $event)),
                                      items: [
                                                { key: 'default', value: 'Kombiniert (Standard)' },
                                                { key: 'visual', value: 'Visuelle Merkmale' },
                                                { key: 'audio', value: 'Audiodaten' },
                                                { key: 'metadata', value: 'Metadaten' },
                                            ],
                                      "item-value": (item) => item.key,
                                      "item-text": (item) => item.value,
                                      "item-title": (item) => item.value,
                                      label: "Ähnlichkeitsmethode",
                                      disabled: _unref(dedupLoading)
                                    }, null, 8, ["modelValue", "item-value", "item-text", "item-title", "disabled"])
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(FormSelect, {
                                      modelValue: processingPriority.value,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((processingPriority).value = $event)),
                                      items: [
                                                { key: 'normal', value: 'Normal' },
                                                { key: 'high', value: 'Hoch' },
                                                { key: 'low', value: 'Niedrig' },
                                            ],
                                      "item-value": (item) => item.key,
                                      "item-text": (item) => item.value,
                                      "item-title": (item) => item.value,
                                      label: "Verarbeitungspriorität",
                                      disabled: _unref(dedupLoading)
                                    }, null, 8, ["modelValue", "item-value", "item-text", "item-title", "disabled"])
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_component_v_checkbox, {
                                      id: "useCache",
                                      modelValue: useCache.value,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((useCache).value = $event)),
                                      color: "#db0720",
                                      label: "Cache verwenden (schneller, falls verfügbar)",
                                      disabled: _unref(dedupLoading)
                                    }, null, 8, ["modelValue", "disabled"])
                                  ]),
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_v_checkbox, {
                                      id: "savePrefs",
                                      modelValue: savePreferences.value,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((savePreferences).value = $event)),
                                      color: "#db0720",
                                      label: "Diese Einstellungen speichern",
                                      disabled: _unref(dedupLoading)
                                    }, null, 8, ["modelValue", "disabled"])
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(FullButton, {
                      handleClick: executeDeduplication,
                      title: 
                                    _unref(dedupLoading) || isExecuting.value
                                        ? 'Lädt...'
                                        : 'Deduplikation starten'
                                ,
                      style: {"width":"49%"},
                      width: "100",
                      colour: _unref(dedupLoading) || isExecuting.value ? 'red' : 'red'
                    }, null, 8, ["title", "colour"]),
                    (_unref(dedupLoading) || isExecuting.value)
                      ? (_openBlock(), _createBlock(FullButton, {
                          key: 0,
                          handleClick: cancelDeduplication,
                          title: "Deduplikation abbrechen",
                          style: {"width":"49%"},
                          width: "100",
                          colour: "gray"
                        }))
                      : _createCommentVNode("", true),
                    (!_unref(dedupLoading) && !isExecuting.value)
                      ? (_openBlock(), _createBlock(FullButton, {
                          key: 1,
                          handleClick: resetEverything,
                          title: "Zurücksetzen",
                          style: {"width":"49%"},
                          width: "100",
                          colour: "gray"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          (hasRun.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "font-medium" }, "Status:", -1)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(stageName) || 'Initialisiere...'), 1),
                        (_unref(substageName))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "(" + _toDisplayString(_unref(substageName)) + ")", 1))
                          : _createCommentVNode("", true),
                        (isDebugModeActive.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "DEBUG"))
                          : _createCommentVNode("", true),
                        (_unref(currentStage) === 'error')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, "●"))
                          : (_unref(dedupLoading))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "●"))
                            : (_unref(progress) >= 99)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "●"))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(progressDisplay.value) + " %", 1)
                      ])
                    ]),
                    _createVNode(_component_v_progress_linear, {
                      "model-value": safeProgressWidth.value,
                      color: 
                                    _unref(errorMessage) ? 'error' : _unref(progress) >= 99 ? 'success' : 'primary'
                                ,
                      height: "16",
                      rounded: ""
                    }, null, 8, ["model-value", "color"])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", null, _toDisplayString(_unref(detailedStatusMessage)), 1),
                    (_unref(dedupLoading) && !_unref(errorMessage))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, "⏱️"))
                      : _createCommentVNode("", true)
                  ]),
                  (hasProcessingStats.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        (_unref(processingStats).extraction_speed > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "font-medium" }, "Extraktionsgeschwindigkeit:", -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(processingStats).extraction_speed.toFixed(1)) + " Videos/min ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(processingStats).comparison_speed > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "font-medium" }, "Vergleichsgeschwindigkeit:", -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(processingStats).comparison_speed.toFixed(1)) + " Paare/min ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (
                                    _unref(processingStats).feature_cache_hits > 0 ||
                                    _unref(processingStats).feature_cache_misses > 0
                                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _cache[26] || (_cache[26] = _createElementVNode("span", { class: "font-medium" }, "Cache:", -1)),
                              _createTextVNode(" " + _toDisplayString(cacheStatusText.value), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(processingStats).current_memory_usage_mb > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _cache[27] || (_cache[27] = _createElementVNode("span", { class: "font-medium" }, "Speicherverbrauch:", -1)),
                              _createTextVNode(" " + _toDisplayString(_unref(processingStats).current_memory_usage_mb.toFixed(1)) + " MB ", 1),
                              (_unref(processingStats).peak_memory_usage_mb > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, "(Spitze: " + _toDisplayString(_unref(processingStats).peak_memory_usage_mb.toFixed(1)) + " MB)", 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(currentStage))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(stageName)) + ":", 1),
                        _createElementVNode("div", null, _toDisplayString(_unref(stageDescription)), 1),
                        (_unref(currentSubstage) && _unref(substageDescription))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(substageName)) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(_unref(substageDescription)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (showActivityLog.value && _unref(latestActivities).length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "font-medium" }, "Letzte Aktivitäten:", -1)),
                          _createVNode(_component_v_btn, {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (showActivityLog.value = !showActivityLog.value)),
                            size: "small",
                            variant: "text",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                              _createTextVNode(" Verbergen ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("ul", _hoisted_45, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(latestActivities), (activity, idx) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: idx,
                              class: "border-b border-gray-100 pb-1"
                            }, [
                              _createElementVNode("span", _hoisted_46, _toDisplayString(formatTimestamp(activity.timestamp)), 1),
                              _createElementVNode("span", _hoisted_47, _toDisplayString(activity.activity), 1)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_unref(latestActivities).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createVNode(_component_v_btn, {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (showActivityLog.value = true)),
                            size: "small",
                            variant: "text",
                            color: "primary"
                          }, {
                            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                              _createTextVNode(" Aktivitätsprotokoll anzeigen ", -1)
                            ]))]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                  (_unref(errorMessage))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "font-medium" }, "Fehler:", -1)),
                        _createElementVNode("div", null, _toDisplayString(_unref(errorMessage)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(deduplicationReport) && !_unref(dedupLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "w-10 h-10 bg-[#db0720] text-white rounded-xl flex items-center justify-center" }, [
                    _createElementVNode("i", { class: "bi-check2-circle text-lg" })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _cache[33] || (_cache[33] = _createElementVNode("h2", { class: "text-3xl font-bold text-gray-800" }, " Deduplikationsergebnisse ", -1)),
                    _createElementVNode("div", _hoisted_53, [
                      (isDebugModeActive.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, " DEBUG DATEN "))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_55, " Abgeschlossen um " + _toDisplayString(new Date().toLocaleTimeString('de-DE')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("button", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (exportResults('csv'))),
                    class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                  }, " CSV "),
                  _createElementVNode("button", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (exportResults('json'))),
                    class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                  }, " JSON "),
                  _createElementVNode("button", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (exportResults('pdf'))),
                    class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200"
                  }, " PDF ")
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _cache[39] || (_cache[39] = _createElementVNode("h3", { class: "text-2xl font-bold mb-6 text-gray-800" }, "Zusammenfassung", -1)),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "text-sm font-medium text-blue-600 mb-2" }, " Gesamtzahl Videos ", -1)),
                    _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(deduplicationReport).stats?.total_videos || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "text-sm font-medium text-purple-600 mb-2" }, " Duplikatgruppen ", -1)),
                    _createElementVNode("div", _hoisted_62, _toDisplayString(_unref(deduplicationReport).stats?.duplicate_clusters ||
                                    _unref(deduplicationReport).duplicate_clusters?.length ||
                                    0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-sm font-medium text-orange-600 mb-2" }, " Duplikatpaare ", -1)),
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(deduplicationReport).stats?.duplicate_pairs || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "text-sm font-medium text-green-600 mb-2" }, " Verarbeitungszeit ", -1)),
                    _createElementVNode("div", _hoisted_66, _toDisplayString(formatProcessingTime(
                                        _unref(deduplicationReport).stats?.processing_time_seconds || 0
                                    )), 1)
                  ])
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _cache[40] || (_cache[40] = _createElementVNode("h3", { class: "text-2xl font-bold text-gray-800" }, "Verarbeitungszeiten", -1)),
                      _createElementVNode("button", {
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (showStageTimes.value = !showStageTimes.value)),
                        class: "flex items-center px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors duration-200"
                      }, [
                        _createTextVNode(_toDisplayString(showStageTimes.value ? 'Verbergen' : 'Details anzeigen') + " ", 1),
                        _createElementVNode("i", {
                          class: _normalizeClass(["bi-chevron-down ml-2 text-[#db0720] transition-transform duration-200", { 'rotate-180': !showStageTimes.value }])
                        }, null, 2)
                      ])
                    ]),
                    (showStageTimes.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200" }, [
                            _createElementVNode("div", { class: "grid grid-cols-3 gap-4 font-semibold text-sm text-gray-700" }, [
                              _createElementVNode("div", null, "Phase"),
                              _createElementVNode("div", null, "Zeit"),
                              _createElementVNode("div", null, "Anteil")
                            ])
                          ], -1)),
                          _createElementVNode("div", _hoisted_70, [
                            (_ctx.time && typeof _ctx.time === 'number' && _ctx.time > 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(stageTimes), (time, stage) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: stage,
                                    class: "px-6 py-4 hover:bg-gray-50 transition-colors duration-200"
                                  }, [
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("div", _hoisted_72, _toDisplayString(getStageDisplayName(stage)), 1),
                                      _createElementVNode("div", _hoisted_73, _toDisplayString(formatTime(time)), 1),
                                      _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("span", _hoisted_75, _toDisplayString(calculatePercentage(time)) + "% ", 1)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _cache[42] || (_cache[42] = _createElementVNode("h3", { class: "text-2xl font-bold text-gray-800" }, "Duplikatgruppen", -1)),
                  _createElementVNode("button", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (showClusters.value = !showClusters.value)),
                    class: "flex items-center px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors duration-200"
                  }, [
                    _createTextVNode(_toDisplayString(showClusters.value ? 'Gruppen verbergen' : 'Gruppen anzeigen') + " ", 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["bi-chevron-down ml-2 text-[#db0720] transition-transform duration-200", { 'rotate-180': !showClusters.value }])
                    }, null, 2)
                  ])
                ])
              ]),
              (showClusters.value && _unref(deduplicationReport).duplicate_clusters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deduplicationReport).duplicate_clusters, (cluster, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `cluster-${index}`,
                        class: "bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
                      }, [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, _toDisplayString(index + 1), 1),
                              _createElementVNode("h4", _hoisted_83, " Gruppe #" + _toDisplayString(index + 1), 1)
                            ]),
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("span", _hoisted_85, _toDisplayString(cluster.videos?.length || 0) + " Videos ", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cluster.videos, (video) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: video.media_id,
                                class: "bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 hover:border-gray-300"
                              }, [
                                _createElementVNode("div", _hoisted_88, [
                                  _createElementVNode("img", {
                                    src: getThumbnailUrl(video.media_id, video),
                                    class: "absolute inset-0 w-full h-full object-contain",
                                    alt: "Video Thumbnail"
                                  }, null, 8, _hoisted_89),
                                  _createElementVNode("div", _hoisted_90, _toDisplayString(video.duration || '0:00'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_91, [
                                  _createElementVNode("h5", _hoisted_92, _toDisplayString(video.title), 1),
                                  _createElementVNode("p", _hoisted_93, _toDisplayString(video.secondary_title), 1),
                                  _createElementVNode("p", _hoisted_94, _toDisplayString(video.description), 1),
                                  (video.similar_videos?.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                        _cache[43] || (_cache[43] = _createElementVNode("p", { class: "text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide" }, " Ähnliche Videos: ", -1)),
                                        _createElementVNode("div", _hoisted_96, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(video.similar_videos, (similar) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: similar.media_id,
                                              class: "flex justify-between items-center py-1"
                                            }, [
                                              _createElementVNode("span", _hoisted_97, _toDisplayString(similar.title
                                                                ? similar.title.length > 20
                                                                    ? similar.title.substring(
                                                                          0,
                                                                          20
                                                                      ) + '...'
                                                                    : similar.title
                                                                : _unref(formatMediaId)(similar.media_id)), 1),
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["px-2 py-1 text-xs font-bold rounded-full text-white", {
                                                            'bg-green-500':
                                                                similar.similarity >= 0.8,
                                                            'bg-orange-500':
                                                                similar.similarity >= 0.6 &&
                                                                similar.similarity < 0.8,
                                                            'bg-red-500': similar.similarity < 0.6,
                                                        }])
                                              }, _toDisplayString(Math.round(similar.similarity * 100)) + "% ", 3)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (openCompareModal(video.media_id, cluster)),
                                    class: "w-full bg-[#db0720] hover:bg-[#c1061c] text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
                                  }, [...(_cache[44] || (_cache[44] = [
                                    _createElementVNode("i", { class: "bi-search text-sm" }, null, -1),
                                    _createElementVNode("span", null, "Vergleichen", -1)
                                  ]))], 8, _hoisted_98)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showCompareModal.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((showCompareModal).value = $event)),
      "max-width": "1400px",
      persistent: "",
      class: "comparison-modal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "rounded-2xl overflow-hidden" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-b border-gray-200" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_99, [
                  _cache[46] || (_cache[46] = _createElementVNode("div", { class: "flex items-center space-x-3" }, [
                    _createElementVNode("div", { class: "w-8 h-8 bg-[#db0720] text-white rounded-full flex items-center justify-center" }, [
                      _createElementVNode("i", { class: "bi-search text-sm" })
                    ]),
                    _createElementVNode("h3", { class: "text-2xl font-bold text-gray-800" }, "Duplikate vergleichen")
                  ], -1)),
                  _createElementVNode("button", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (showCompareModal.value = false)),
                    class: "w-8 h-8 rounded-full hover:bg-gray-200 flex items-center justify-center transition-colors duration-200"
                  }, [...(_cache[45] || (_cache[45] = [
                    _createElementVNode("i", { class: "bi-x text-xl text-gray-600" }, null, -1)
                  ]))])
                ])
              ]),
              _: 1
            }),
            (compareData.value)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  class: "p-6"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, [
                            _cache[47] || (_cache[47] = _createElementVNode("div", { class: "w-6 h-6 bg-blue-500 text-white rounded-full flex items-center justify-center text-xs font-bold" }, " 1 ", -1)),
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("h4", _hoisted_105, _toDisplayString(compareData.value.primary.title), 1),
                              _createElementVNode("p", _hoisted_106, _toDisplayString(compareData.value.primary.secondary_title), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "relative aspect-video bg-gray-100 rounded-xl overflow-hidden group cursor-pointer",
                          style: {"min-height":"200px"},
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (playVideo(compareData.value.primary.media_id)))
                        }, [
                          _createElementVNode("img", {
                            src: getThumbnailUrl(compareData.value.primary.media_id, compareData.value.primary),
                            class: "absolute inset-0 w-full h-full object-contain",
                            alt: "Primary Video"
                          }, null, 8, _hoisted_107),
                          _createElementVNode("div", _hoisted_108, _toDisplayString(compareData.value.primary.duration || 'Unbekannt'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_109, [
                          _cache[48] || (_cache[48] = _createElementVNode("h5", { class: "font-semibold text-gray-700 mb-2" }, "Beschreibung", -1)),
                          _createElementVNode("p", _hoisted_110, _toDisplayString(compareData.value.primary.description), 1)
                        ]),
                        _createElementVNode("div", _hoisted_111, [
                          _createElementVNode("div", _hoisted_112, [
                            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "font-semibold text-gray-700" }, "Dauer:", -1)),
                            _createElementVNode("span", _hoisted_113, _toDisplayString(compareData.value.primary.duration || 'Unbekannt'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_114, [
                            _cache[50] || (_cache[50] = _createElementVNode("span", { class: "font-semibold text-gray-700" }, "Sprache(n):", -1)),
                            _createElementVNode("span", _hoisted_115, _toDisplayString(formatLanguages(compareData.value.primary.languages)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_116, [
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("div", _hoisted_118, [
                            _createElementVNode("div", _hoisted_119, [
                              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center text-xs font-bold" }, " 2 ", -1)),
                              _createElementVNode("div", _hoisted_120, [
                                _createElementVNode("h4", _hoisted_121, _toDisplayString(compareData.value.comparison.title), 1),
                                _createElementVNode("p", _hoisted_122, _toDisplayString(compareData.value.comparison.secondary_title), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_123, [
                              _createVNode(_component_v_select, {
                                modelValue: selectedComparisonId.value,
                                "onUpdate:modelValue": [
                                  _cache[16] || (_cache[16] = ($event: any) => ((selectedComparisonId).value = $event)),
                                  updateComparisonVideo
                                ],
                                items: compareData.value.otherVideos,
                                "item-value": "media_id",
                                "item-title": "title",
                                variant: "outlined",
                                density: "compact",
                                class: "min-w-[200px]"
                              }, {
                                item: _withCtx(({ props, item }) => [
                                  _createVNode(_component_v_list_item, _mergeProps(props, {
                                    title: `${item.raw.title.length > 25 ? item.raw.title.substring(0, 25) + '...' : item.raw.title}`,
                                    subtitle: `${Math.round(item.raw.similarity * 100)}% Ähnlichkeit`
                                  }), null, 16, ["title", "subtitle"])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "items"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "relative aspect-video bg-gray-100 rounded-xl overflow-hidden group cursor-pointer",
                          style: {"min-height":"200px"},
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (playVideo(compareData.value.comparison.media_id)))
                        }, [
                          _createElementVNode("img", {
                            src: getThumbnailUrl(compareData.value.comparison.media_id, compareData.value.comparison),
                            class: "absolute inset-0 w-full h-full object-contain",
                            alt: "Comparison Video"
                          }, null, 8, _hoisted_124),
                          _createElementVNode("div", _hoisted_125, _toDisplayString(compareData.value.comparison.duration || 'Unbekannt'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_126, [
                          _cache[52] || (_cache[52] = _createElementVNode("h5", { class: "font-semibold text-gray-700 mb-2" }, "Beschreibung", -1)),
                          _createElementVNode("p", _hoisted_127, _toDisplayString(compareData.value.comparison.description), 1)
                        ]),
                        _createElementVNode("div", _hoisted_128, [
                          _createElementVNode("div", _hoisted_129, [
                            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "font-semibold text-gray-700" }, "Dauer:", -1)),
                            _createElementVNode("span", _hoisted_130, _toDisplayString(compareData.value.comparison.duration || 'Unbekannt'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_131, [
                            _cache[54] || (_cache[54] = _createElementVNode("span", { class: "font-semibold text-gray-700" }, "Sprache(n):", -1)),
                            _createElementVNode("span", _hoisted_132, _toDisplayString(formatLanguages(compareData.value.comparison.languages)), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_133, [
                      _cache[58] || (_cache[58] = _createElementVNode("div", { class: "flex items-center space-x-3 mb-6" }, [
                        _createElementVNode("div", { class: "w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center" }, [
                          _createElementVNode("i", { class: "bi-bar-chart text-sm" })
                        ]),
                        _createElementVNode("h4", { class: "text-xl font-bold text-gray-800" }, "Ähnlichkeitsanalyse")
                      ], -1)),
                      (compareData.value.similarityDetails)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                            _createElementVNode("div", _hoisted_135, [
                              _createElementVNode("div", _hoisted_136, [
                                _cache[55] || (_cache[55] = _createElementVNode("h5", { class: "text-lg font-semibold text-gray-700" }, " Gesamtähnlichkeit ", -1)),
                                _createElementVNode("div", _hoisted_137, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["px-3 py-1 text-lg font-bold text-white rounded-full", {
                                            'bg-green-500':
                                                compareData.value.similarityDetails.overall >= 0.8,
                                            'bg-orange-500':
                                                compareData.value.similarityDetails.overall >= 0.6 &&
                                                compareData.value.similarityDetails.overall < 0.8,
                                            'bg-red-500':
                                                compareData.value.similarityDetails.overall < 0.6,
                                        }])
                                  }, _toDisplayString(Math.round(compareData.value.similarityDetails.overall * 100)) + "% ", 3)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_138, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["h-4 rounded-full transition-all duration-500", {
                                        'bg-green-500':
                                            compareData.value.similarityDetails.overall >= 0.8,
                                        'bg-orange-500':
                                            compareData.value.similarityDetails.overall >= 0.6 &&
                                            compareData.value.similarityDetails.overall < 0.8,
                                        'bg-red-500': compareData.value.similarityDetails.overall < 0.6,
                                    }]),
                                  style: _normalizeStyle({
                                        width: `${compareData.value.similarityDetails.overall * 100}%`,
                                    })
                                }, null, 6)
                              ])
                            ]),
                            (compareData.value.similarityDetails?.matching_segments?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                  _cache[57] || (_cache[57] = _createElementVNode("h5", { class: "text-lg font-semibold text-gray-700 mb-4" }, " Übereinstimmende Segmente ", -1)),
                                  _createElementVNode("div", _hoisted_140, [
                                    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "grid grid-cols-3 gap-4 p-4 bg-gray-50 border-b border-gray-200 font-semibold text-sm text-gray-700" }, [
                                      _createElementVNode("div", null, "Startzeit"),
                                      _createElementVNode("div", null, "Dauer"),
                                      _createElementVNode("div", null, "Konfidenz")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_141, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compareData.value.similarityDetails
                                            .matching_segments, (segment, i) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: i,
                                          class: "grid grid-cols-3 gap-4 p-4 hover:bg-gray-50 transition-colors duration-200"
                                        }, [
                                          _createElementVNode("div", _hoisted_142, _toDisplayString(segment.start), 1),
                                          _createElementVNode("div", _hoisted_143, _toDisplayString(segment.duration), 1),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["px-2 py-1 text-xs font-bold rounded-full text-white", {
                                                    'bg-green-500': segment.confidence > 0.8,
                                                    'bg-orange-500':
                                                        segment.confidence > 0.7 &&
                                                        segment.confidence <= 0.8,
                                                    'bg-red-500': segment.confidence <= 0.7,
                                                }])
                                            }, _toDisplayString(Math.round(segment.confidence * 100)) + "% ", 3)
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, { class: "px-6 py-4 bg-gray-50 border-t border-gray-200" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_144, [
                  _createElementVNode("button", {
                    onClick: closeCompareModal,
                    class: "px-6 py-2.5 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors duration-200 font-medium"
                  }, " Abbrechen "),
                  _createElementVNode("button", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (
                            markAsUnique(
                                compareData.value.primary.media_id,
                                compareData.value.comparison.media_id
                            )
                        )),
                    class: "px-6 py-2.5 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium"
                  }, " Kein Duplikat "),
                  _createElementVNode("button", {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (
                            mergeDuplicates(
                                compareData.value.primary.media_id,
                                compareData.value.comparison.media_id
                            )
                        )),
                    class: "px-6 py-2.5 bg-[#db0720] hover:bg-[#c1061c] text-white rounded-lg transition-colors duration-200 font-medium"
                  }, " Zusammenführen ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})